/* tslint:disable */
/* eslint-disable */
/**
 * SBL API Glommen Mjøsen Skog
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { GmModelLibraryModelsAssortmentModel } from '../model';
/**
 * AssortmentApi - axios parameter creator
 * @export
 */
export const AssortmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all assortments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assortmentGetAssortments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/assortments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssortmentApi - functional programming interface
 * @export
 */
export const AssortmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssortmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all assortments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assortmentGetAssortments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GmModelLibraryModelsAssortmentModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assortmentGetAssortments(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AssortmentApi.assortmentGetAssortments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AssortmentApi - factory interface
 * @export
 */
export const AssortmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssortmentApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all assortments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assortmentGetAssortments(options?: any): AxiosPromise<Array<GmModelLibraryModelsAssortmentModel>> {
            return localVarFp.assortmentGetAssortments(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssortmentApi - object-oriented interface
 * @export
 * @class AssortmentApi
 * @extends {BaseAPI}
 */
export class AssortmentApi extends BaseAPI {
    /**
     * 
     * @summary Get all assortments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssortmentApi
     */
    public assortmentGetAssortments(options?: RawAxiosRequestConfig) {
        return AssortmentApiFp(this.configuration).assortmentGetAssortments(options).then((request) => request(this.axios, this.basePath));
    }
}

